import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/cluster", null, {}, {
    "Accept": ["application/json"]
  });
}
export function clusterProcessBufferDump() {
  return __request__("GET", "/cluster/processbufferdump", null, {}, {
    "Accept": ["application/json"]
  });
}
export function jvm(nodeId) {
  return __request__("GET", `/cluster/${nodeId}/jvm`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function processBufferDump(nodeId) {
  return __request__("GET", `/cluster/${nodeId}/processbufferdump`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function threadDump(nodeId) {
  return __request__("GET", `/cluster/${nodeId}/threaddump`, null, {}, {
    "Accept": ["application/json"]
  });
}
